import apiClient from './apiClient';

export interface WorkLocation {
  id: string;
  name: string;
  description?: string | null;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

type Envelope<T> = { success?: boolean; data?: T; error?: string };

const unwrap = <T>(response: unknown): T => {
  const r = response as { data?: unknown; status?: number };
  const body = typeof r?.status === 'number' ? r.data : response;
  const env = body as Envelope<T>;
  return env && Object.prototype.hasOwnProperty.call(env, 'data')
    ? (env.data as T)
    : (body as T);
};

class WorkLocationsService {
  async list(includeInactive = false): Promise<WorkLocation[]> {
    const query = includeInactive ? '?includeInactive=true' : '';
    const response = await apiClient.get<Envelope<WorkLocation[]>>(`/work-locations${query}`);
    return unwrap<WorkLocation[]>(response) ?? [];
  }

  async create(input: { name: string; description?: string }): Promise<WorkLocation> {
    const response = await apiClient.post<Envelope<WorkLocation>>('/work-locations', input);
    return unwrap<WorkLocation>(response);
  }

  async update(
    id: string,
    input: { name?: string; description?: string | null; isActive?: boolean }
  ): Promise<WorkLocation> {
    const response = await apiClient.patch<Envelope<WorkLocation>>(`/work-locations/${id}`, input);
    return unwrap<WorkLocation>(response);
  }

  async remove(id: string): Promise<void> {
    await apiClient.delete<void>(`/work-locations/${id}`);
  }
}

export default new WorkLocationsService();
